import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import emitter from "../Game/Events/EventManager";
import {
  LEFT_EXIT,
  RIGHT_EXIT,
  LEFT_GO,
  RIGHT_GO,
  QUIT_GAME2,
  RESTART_GAME,
} from "../Game/Events/Events";
import {
  CHOOSE_TC,
  CHOOSE_SC,
  CHOOSE_EN,
  NEXT_PROGRESS,
  QUIT_GAME,
} from "../Game/Events/Events";
import store from "../store/store.jsx";
import { dispatchChangeScene, dispatchChangeLang } from "../Game/reducers/sceneReducer";

export default function EndingSceneOverlay() {
  const totalScore = useSelector((state) => state.currentScene.currentScore);
  const lang = useSelector((state) => state.currentScene.currentLang) || "TC";

  const TC_texts = {
    totalScore: "總分：",
    restart: "回到主頁, 按 Enter",
    playAgain: "再玩一次, 按 Enter",
  };

  const EN_texts = {
    totalScore: "Total Score: ",
    restart: "To Main Page, press Enter",
    playAgain: "Play Again, press Enter",
  };

  const SC_texts = {
    totalScore: "总分：",
    restart: "回到主页, 按 Enter",
    playAgain: "再玩一次, 按 Enter",
  };

  let texts;
  if (lang == "TC") texts = TC_texts;
  if (lang == "SC") texts = SC_texts;
  if (lang == "EN") texts = EN_texts;

  return (
    <div className="hidden">
      <div tabIndex="1">{texts.totalScore + totalScore}</div>
      <div
        tabIndex="2"
        onKeyDown={(e) => {
          if (e.keyCode == 13) {
            emitter.emit(QUIT_GAME2);
          }
        }}
      >
        {texts.restart}
      </div>

      <div
        tabIndex="3"
        onKeyDown={(e) => {
          if (e.keyCode == 13) {
            emitter.emit(RESTART_GAME);
          }
        }}
      >
        {texts.playAgain}
      </div>
    </div>
  );
}
